// Wraps occurrences of the searched term(s) inside a block of text with a soft glowing
// highlight so the match is easy to spot in Scripture search results.
const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default function Highlight({ text, query, className = "" }) {
  const t = String(text ?? "");
  const terms = (query || "")
    .trim()
    .split(/\s+/)
    .filter((w) => w.replace(/[^\p{L}\p{N}]/gu, "").length > 1)
    .map(escapeRegex);
  if (!terms.length || !t) return t;

  const splitter = new RegExp(`(${terms.join("|")})`, "gi");
  const matcher = new RegExp(`^(${terms.join("|")})$`, "i");
  const parts = t.split(splitter);

  return parts.map((p, i) =>
    matcher.test(p) ? (
      <mark
        key={i}
        data-testid="search-highlight"
        className={`search-glow rounded px-0.5 ${className}`}
      >
        {p}
      </mark>
    ) : (
      <span key={i}>{p}</span>
    )
  );
}
